import React, { useEffect } from "react";

// material-ui
import { makeStyles } from "@material-ui/core/styles";
import styles from "./styles-mui.js";

// styles
import { HeaderTextContainer } from "./styles.js";

// @material-ui/icons
import { ArrowBack, Iso } from "@material-ui/icons";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardText from "components/Card/CardText.js";

import { useHistory } from "react-router-dom";
import ControlledAccordion from "./Accordion.jsx";
import RegularButton from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

export default function VolumetricDetails() {
    const history = useHistory();

    const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
    const classes = useStyles();

    useEffect(() => {
        let anim = setTimeout(function () {
            setCardAnimation("");
        }, 800);

        return () => {
            clearTimeout(anim)
        }
    }, [])

    return (
        <GridContainer >
        <GridItem  xs={12} sm={12} md={12}>
            <Card login className={`${classes[cardAnimaton]}`}>
            <CardHeader color='info' text className={classes.cardHeaderHover}>
                <CardText className={classes.cardHeader} color='info'>
                <HeaderTextContainer>
                    <Iso />
                    <h5 className={classes.cardTitle}>Detalles Volumetricos</h5>
                </HeaderTextContainer>
                </CardText>
                <RegularButton
                    justIcon
                    round
                    color="info"
                    onClick={() => history.goBack()}
                    style={{ marginTop: -18, marginLeft: 140, position: "absolute", top: 0, right: 0 }}
                >
                    <ArrowBack />
                </RegularButton>
            </CardHeader>
            <CardBody
                className={`${classes.cardNoPadding} ${classes.marginCard}`}
                style={{ display: 'flex', flexWrap: 'Wrap' }}
            >
                <ControlledAccordion />
            </CardBody>
            </Card>
        </GridItem>
        </GridContainer>
    );
}